import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {getProduct, searchProductStockBatches} from "./actions";
import {Button} from "antd";
import DateTimeDisplay from "../common/DateTimeDisplay";
import MoneyDisplay from "../common/MoneyDisplay";
import {decodeParams} from "../utils/params";

class BatchesPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    product: PropTypes.object,
    productLoading: PropTypes.bool.isRequired,
    /* actions */
    searchProductStockBatches: PropTypes.func.isRequired,
    getProduct: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params !== this.props.match.params) this._load();
  }

  _load() {
    const {productId} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
  }

  render() {
    const {
      history, searchProductStockBatches, product, productLoading,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      match: {params},
    } = this.props;
    if (!product || productLoading) return null;
    const {productId, sku: paramSku} = decodeParams(params);
    const sku = paramSku === '-' ? '' : paramSku;
    const columns = [
      {
        title: 'Received At',
        dataIndex: 'receivedAt',
        key: 'receivedAt',
        sorter: true,
        render: (receivedAt) => <DateTimeDisplay dateTime={receivedAt}/>
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        sorter: true,
      },
      {
        title: 'Cost Price',
        dataIndex: 'netCostPerUnit',
        key: 'netCostPerUnit',
        sorter: true,
        render: (costPrice) => <MoneyDisplay amount={costPrice} decimals={5}/>
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 120,
        render: product.archived ? undefined : (_, {productId, sku, receivedAt}) =>
          <Link to={`/product/correct-batch/${encodeURIComponent(productId)}/${encodeURIComponent(sku || '-')}/${encodeURIComponent(receivedAt)}`}>Correct</Link>,
      }
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          ` ${product.name} ${sku} Batches`
        ]}
        searchPlaceholder="Search sku and lot number"
        loading={searching}
        columns={columns}
        dataSourceProvider={
          (payload) => searchProductStockBatches({...payload, filters: {...payload.filters, productId, sku}})
        }
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        rowKey={row => `${row.receivedAt}-${row.sku}-${row.productId}`}
      />
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  search: state.product.stockBatchesSearch,
  product: state.product.product,
  productLoading: state.product.productLoading,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductStockBatches,
  getProduct,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(BatchesPage);



// WEBPACK FOOTER //
// ./src/Product/BatchesPage.js